import CONFIG from "../config";
export const BASE_API_URL = CONFIG.BASE_URL;
